import { Trans } from "react-i18next";

export function PurchasePolicyDisclaimer() {
  return (
    <p>
      <Trans
        i18nKey="purchasePolicyDisclaimer"
        components={{
          1: <strong />,
          2: (
            <a
              href="https://www.getnexar.com/purchase-policy/"
              target="_blank"
              rel="noreferrer"
            />
          ),
        }}
      />
    </p>
  );
}
